// Verplichte velden in de helpdesk: welke ontbreken er nog?
//
// Vraag 21-09-2026: bij een nieuw ticket of een antwoord was niet duidelijk WAT er
// nog ontbrak (de knop stond gewoon uit, of er kwam één zin bovenaan). Nu mag je
// altijd op de knop drukken; ontbreekt er iets, dan krijgt elk leeg verplicht veld
// een dik rood kader en noemt een korte melding de velden bij naam.
//
// Hier staat alleen de REGEL (zuivere functies, getest); het scherm tekent de
// kaders met <HdVerplicht> en toont de melding met meldOntbrekend() in App.jsx.
import { slotPositie } from './mailGroet';

const tekstVan = (html) => String(html || '')
  .replace(/<(br|\/p|\/div|\/li)\s*\/?>/gi, ' ')
  .replace(/<[^>]*>/g, '')
  .replace(/&nbsp;|&#160;/gi, ' ')
  .replace(/\s+/g, ' ')
  .trim();

// Een bericht is leeg als er geen tekst in staat, of ALLEEN de vaste groet
// ("Heb je bijkomende vragen? … Met energieke groeten, …"). Die staat vooraf in
// het tekstvak; een mail met enkel de groet is geen antwoord.
export function isLeegBericht(html) {
  const bron = String(html || '');
  const p = slotPositie(bron);
  return tekstVan(p >= 0 ? bron.slice(0, p) : bron) === '';
}

const veld = (id, label) => ({ id, label });

// Nieuw ticket. `kanaal`: 'mail' | 'intern' | 'geen'. Volgorde = volgorde op het scherm.
// Bij 'intern' is `bericht` de interne notitie: gewone tekst, zonder vaste groet.
export function ontbrekendNieuwTicket({ klantGekozen, onderwerp, teamId, tagNamen, kanaal, aan, bericht }) {
  const uit = [];
  if (!klantGekozen) uit.push(veld('klant', 'Klant'));
  if (!String(onderwerp || '').trim()) uit.push(veld('onderwerp', 'Onderwerp'));
  if (!teamId) uit.push(veld('team', 'Klantenserviceteam'));
  if (!(tagNamen && tagNamen.length)) uit.push(veld('tags', 'Tags'));
  if (kanaal === 'mail' && !String(aan || '').trim()) uit.push(veld('aan', 'Aan (e-mailadres)'));
  if (kanaal === 'intern' && !String(bericht || '').trim()) uit.push(veld('bericht', 'Interne notitie'));
  if (kanaal === 'mail' && isLeegBericht(bericht)) uit.push(veld('bericht', 'Bericht'));
  return uit;
}

// Antwoord per mail op een bestaand ticket.
export function ontbrekendMail({ aan, onderwerp, bericht }) {
  const uit = [];
  if (!String(aan || '').trim()) uit.push(veld('aan', 'Aan (e-mailadres)'));
  if (!String(onderwerp || '').trim()) uit.push(veld('onderwerp', 'Onderwerp'));
  if (isLeegBericht(bericht)) uit.push(veld('bericht', 'Bericht'));
  return uit;
}

// Bericht naar de klant of interne notitie op een bestaand ticket.
export function ontbrekendBericht({ bericht }) {
  return String(bericht || '').trim() ? [] : [veld('bericht', 'Bericht')];
}

// "Klant, Tags en Bericht" — voor de korte melding.
export function somOp(velden) {
  const namen = velden.map((v) => v.label);
  if (namen.length <= 1) return namen.join('');
  return `${namen.slice(0, -1).join(', ')} en ${namen[namen.length - 1]}`;
}
